<template>
  <base-layout>
    <template v-slot:header>
      <router-view></router-view>
      <h1 class="text-3xl font-bold leading-tight text-gray-900">
        Edukacija
      </h1>
    </template>
    <template v-slot:default>
      <div class="space-y-8 divide-y divide-gray-200 sm:space-y-5 mb-5">
        <div>
          <div>
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Uradi test
            </h3>
            <p class="mt-1 max-w-4xl text-sm text-gray-500">
              Proverite svoje znanje iz zadatih oblasti. Svaki test se može
              uraditi samo jednom, a ostvaren broj poena po testu će biti
              vidljiv naknadno.
            </p>
          </div>
        </div>
      </div>

      <div class="flex flex-col">
        <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div
            class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8"
          >
            <div
              class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg"
            >
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      class="sm:pl-6 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Vreme postavljanja testa
                    </th>
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                  <tr
                    class="hover:bg-gray-50 cursor-pointer"
                    @click="$router.push(`/education/tests/${quiz.id}`)"
                    v-for="(quiz, index) in quizzes"
                    :key="index"
                  >
                    <td
                      class="min-w-0 flex-1 flex items-center justify-between sm:pl-6 px-6 py-4"
                    >
                      <div>
                        <div class="text-sm text-gray-900">
                          {{ quiz.title }}
                        </div>
                        <div class="text-sm text-gray-500">
                          <div class="flex items-center text-sm text-gray-500">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                            >
                              <path
                                d="M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zM14.553 7.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z"
                              />
                            </svg>
                            <p>
                              <time>{{ quiz.anchor_html }} h</time>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div>
                        <svg
                          class="h-5 w-5 text-gray-400"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                            clip-rule="evenodd"
                          />
                        </svg>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </template>
  </base-layout>
</template>

<script>
import EducationTests from "./EducationTests";
export default EducationTests;
</script>
